import { NewReportRoute, RoutePrefix } from '../../../Routes';
import { RouteName } from '../@data/store/store';

export const isPubcenterReporting = (): boolean => {
  return window.location.pathname.includes(NewReportRoute);
};

export const isPubCenterReportingLandingPage = (): boolean => {
  return window.location.pathname.includes(`${RouteName.landing}`);
};

export const isReportUI = (): boolean => {
  return window.location.pathname.includes(RoutePrefix.report);
};
